import {useTranslation} from '@aboutyou/i18n';
import {GenericIconName} from '@aboutyou/ui-components';
import React from 'react';
import {IconMetaNavigationItem} from './IconMetaNavigationItem';

export const IconMetaNavigationItemSearch: React.FC<{
  onClick: React.MouseEventHandler;
}> = ({onClick}) => {
  const {t} = useTranslation();

  return (
    <IconMetaNavigationItem
      dataTestId="stickyHeaderSearchIcon"
      icon={GenericIconName.NavHeaderSearch}
      label={t('Search')}
      onClick={event => {
        onClick(event);
      }}
    />
  );
};
